<template>
  <Transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
  >
    <div v-if="isOpen" ref="menuRef" class="lg:hidden" id="mobile-menu">
      <!-- Navigation Links -->
      <div class="pt-2 pb-3 space-y-1">
        <template v-for="item in menu" :key="item.label">

          <!-- Lien direct simple -->
          <template v-if="item.href">
            <NuxtLink
                :to="item.href"
                @click="handleLinkClick"
                :class="item.class"
                class="block px-3 py-2 rounded-md text-base font-medium"
            >
              {{ t(item.label) }}
            </NuxtLink>

<!--            <button-->
<!--                v-else-->
<!--                @click="scrollToSection(item.href)"-->
<!--                :class="item.class"-->
<!--                class="w-full text-left block px-3 py-2 rounded-md text-base font-medium bg-transparent"-->
<!--            >-->
<!--              {{ t(item.label) }}-->
<!--            </button>-->
          </template>

          <!-- Menu avec sous-éléments -->
          <div v-else-if="item.items" class="space-y-1">
            <!-- Titre du groupe principal -->
            <button
                @click="toggleSubmenu(item.label)"
                class="w-full flex items-center justify-between px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 bg-transparent"
            >
              <span>{{ t(item.label) }}</span>
              <svg
                  :class="{ 'rotate-180': openSubmenus[item.label] }"
                  class="h-5 w-5 transition-transform duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <!-- Sous-menu -->
            <Transition
                enter-active-class="transition duration-200 ease-out"
                enter-from-class="transform scale-95 opacity-0"
                enter-to-class="transform scale-100 opacity-100"
                leave-active-class="transition duration-150 ease-in"
                leave-from-class="transform scale-100 opacity-100"
                leave-to-class="transform scale-95 opacity-0"
            >
              <div v-if="openSubmenus[item.label]" class="pl-4 space-y-1 bg-gray-50 rounded-md py-2">
                <template v-for="subItem in item.items" :key="subItem.href || subItem.label">

                  <!-- Sous-élément direct -->
                  <template v-if="subItem.href">
                    <NuxtLink
                        :to="subItem.href"
                        @click="handleLinkClick"
                        :class="subItem.class"
                        class="block px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-white transition-colors duration-150"

                    >
                      {{ t(subItem.label) }}
                    </NuxtLink>

<!--                    <button-->
<!--                        v-else-->
<!--                        @click="scrollToSection(subItem.href)"-->
<!--                        :class="subItem.class"-->
<!--                        class="w-full text-left block px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-white bg-transparent transition-colors duration-150"-->
<!--                    >-->
<!--                      {{ t(subItem.label) }}-->
<!--                    </button>-->
                  </template>

                  <!-- Sous-élément avec ses propres sous-éléments (Services) -->
                  <div v-else-if="subItem.items" class="space-y-1">
                    <!-- Titre du sous-groupe -->
                    <button
                        @click="toggleSubmenu(`${item.label}_${subItem.label}`)"
                        class="w-full flex items-center justify-between px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-white bg-transparent transition-colors duration-150"
                    >
                      <span>{{ t(subItem.label) }}</span>
                      <svg
                          :class="{ 'rotate-180': openSubmenus[`${item.label}_${subItem.label}`] }"
                          class="h-4 w-4 transition-transform duration-200"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    <!-- Sous-sous-menu (Services individuels) -->
                    <Transition
                        enter-active-class="transition duration-200 ease-out"
                        enter-from-class="transform scale-95 opacity-0"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-150 ease-in"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0"
                    >
                      <div v-if="openSubmenus[`${item.label}_${subItem.label}`]" class="pl-4 space-y-1 bg-white rounded-md py-2 border-l-2 border-green-200">
                        <template v-for="subSubItem in subItem.items" :key="subSubItem.href">
                          <NuxtLink
                              :to="subSubItem.href"
                              @click="handleLinkClick"
                              :class="subSubItem.class"
                              class="block px-3 py-2 rounded-md text-xs font-medium text-gray-500 hover:text-green-600 hover:bg-green-50 transition-colors duration-150"
                          >
                            {{ t(subSubItem.label) }}
                          </NuxtLink>

<!--                          <button-->
<!--                              v-else-if="subSubItem.href"-->
<!--                              @click="scrollToSection(subSubItem.href)"-->
<!--                              :class="subSubItem.class"-->
<!--                              class="w-full text-left block px-3 py-2 rounded-md text-xs font-medium text-gray-500 hover:text-green-600 hover:bg-green-50 bg-transparent transition-colors duration-150"-->
<!--                          >-->
<!--                            {{ t(subSubItem.label) }}-->
<!--                          </button>-->
                        </template>
                      </div>
                    </Transition>
                  </div>

                </template>
              </div>
            </Transition>
          </div>

        </template>
      </div>

      <!-- User Section -->
      <div v-if="isLoggedIn" class="pt-4 pb-3 border-t border-gray-200">
        <MobileUserInfo :user="user" />
        <MobileUserMenu />
      </div>

      <!-- Auth Buttons for Mobile -->
      <div v-else class="px-5 py-3">
        <MobileAuthButtons @click="handleLinkClick" />
      </div>

      <lazy-divider/>

      <div class="flex justify-between px-5 py-3">
        <InternationalisationButtons />
        <ManageButton v-if="isLoggedIn" />
        <AsDevis />
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, reactive } from 'vue'
import { onClickOutside } from '@vueuse/core'

const props = defineProps({
  isOpen: Boolean,
  isLoggedIn: Boolean,
  user: Object,
  currentRoute: String
})

const emit = defineEmits(['close'])

const { t, tm } = useI18n()

// État pour gérer l'ouverture des sous-menus
const openSubmenus = reactive({})

const toggleSubmenu = (key) => {
  openSubmenus[key] = !openSubmenus[key]
}

// Fonction pour générer les services depuis les traductions
const getServicesFromTranslations = () => {
  try {
    // Accéder aux données de traduction des services
    const servicesData = tm('services.items')

    if (!servicesData || typeof servicesData !== 'object') {
      return []
    }

    // Convertir les clés en routes de services
    return Object.keys(servicesData).map(serviceKey => ({
      class: getLinkClasses(`/services/${serviceKey}`),
      href: `/services/${serviceKey}`,
      label: `services.items.${serviceKey}.title` // Pour la cohérence avec t()
    }))
  } catch (error) {
    console.warn('Erreur lors de la récupération des services:', error)
    return []
  }
}

// Structure de menu avec services dynamiques
const menu = computed(() => {
  const dynamicServices = getServicesFromTranslations()

  return [
    {
      label: 'nav.home',
      class:'',
      items: [
        { href: '/#services', label: 'nav.services', class: getAnchorClasses(`/#services`) },
        { href: '/#realisation', label: 'nav.realisation', class: getAnchorClasses(`/#realisation`) },
        { href: '/#about', label: 'nav.about', class: getAnchorClasses(`/#about`) },
        { href: '/#testimonial', label: 'nav.testimonial', class: getAnchorClasses(`/#testimonial`) },
        { href: '/#client', label: 'nav.customer', class: getAnchorClasses(`/#client`) },
        { href: '/#faq', label: 'nav.faq', class: getAnchorClasses(`/#faq`) },
      ]
    },
    {
      label: 'nav.company',
      class:'',
      items: [
        {
          label: 'nav.services',
          items: dynamicServices
        },
        { href: '/realisations', label: 'nav.realisation', class:getLinkClasses(`/realisations`) },
      ]
    },
    { href: '/contact', label: 'nav.contact', class:getLinkClasses(`/contact`) },
    { href: '/faq', label: 'nav.faq', class:getLinkClasses(`/faq`) }
  ]
})

const activeSection = ref('')

const getLinkClasses = (href) => {
  const isActive = props.currentRoute === href
  return isActive
      ? 'bg-red-50 border-red-500 text-red-700'
      : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
}

const getAnchorClasses = (href) => {
  const sectionId = href.replace('/#', '')
  const isActive = activeSection.value === sectionId
  return isActive
      ? 'bg-red-50 border-red-500 text-red-700'
      : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
}

// Détection simple par scroll
const handleScroll = () => {
  const sections = ['services', 'realisation', 'about', 'testimonial', 'client', 'contact']
  const navbarHeight = 80
  const scrollTop = window.scrollY || document.documentElement.scrollTop

  let currentSection = ''
  let minDistance = Infinity

  sections.forEach(sectionId => {
    const element = document.getElementById(sectionId)
    if (element) {
      const distance = Math.abs(element.offsetTop - navbarHeight - scrollTop)
      if (distance < minDistance) {
        minDistance = distance
        currentSection = sectionId
      }
    }
  })

  if (currentSection !== activeSection.value) {
    activeSection.value = currentSection
  }
}

// Version throttlée du scroll pour les performances
let scrollTimeout = null
const throttledHandleScroll = () => {
  if (scrollTimeout) return

  scrollTimeout = setTimeout(() => {
    handleScroll()
    scrollTimeout = null
  }, 100)
}

onMounted(() => {
  window.addEventListener('scroll', throttledHandleScroll)
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', throttledHandleScroll)
  if (scrollTimeout) {
    clearTimeout(scrollTimeout)
  }
})

const menuRef = ref(null)

// Fermer si clic à l'extérieur
onClickOutside(menuRef, () => {
  if (props.isOpen) emit('close')
})

// Fermer quand on clique sur un lien
const handleLinkClick = () => {
  // Fermer tous les sous-menus
  Object.keys(openSubmenus).forEach(key => {
    openSubmenus[key] = false
  })
  emit('close')
}
</script>